import React from 'react'
import arrowRight from "../../assets/images/arrow-right.svg"
import arrowLeft from "../../assets/images/arrow-left.svg"
import { CircularProgress } from '@mui/material'

function Button({type, content, arrow, disabled, width, loading, className, icon, onClick=undefined}) {
    const buttonStyle ={
      backgroundColor: "#74613C",
      padding: "8px 20px",
      border: "none",
      outline: "none",
      borderRadius: "10px",
      color: "white",
      textTransform: "uppercase",
      fontSize: "14px",
      fontWeight: 600,
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      width: width ? width : "fit-content",
      alignItems: "center",
      justifyContent: "center",
      height: 'fit-content',
      fontFamily: "Montserrat"
    }

  return (
    <>
      <button type={type} style={buttonStyle} disabled={disabled} className={`${className} ${disabled ? 'cusor-not-allowed' : ''}`} onClick={onClick}>
          {
            loading && !icon ?
            <CircularProgress sx={{'color': '#fff'}} size={21}/>
            :
            <>
              {icon && !loading ? <span className='me-2'>{icon}</span> : <CircularProgress  sx={{'color': '#fff'}} className='me-2' size={19}/>}
              {arrow==="left" && <img className='pe-2 g' width={"25px"} src={arrowLeft}/>}
              {content}
              {arrow==="right" && <img className='ps-2 g' width={"25px"} src={arrowRight}/>}
            </>
          }
      </button>
    </>
  )
}

export default Button